import convertBackgroundToAbsoluteUrl from './convertBackgroundToAbsoluteUrl.js';
import getDefaultBackground from './getDefaultBackground.js';
/**
 * Converts the Parabo page background to the Polotno page background.
 * @param {object} page Parabo original page data
 * @param {object} pageSpec Parabo page specification data
 * @param {Array} photos Parabo photos
 * @param {object} template Parabo template data
 * @param {boolean} useServerAssets use server_assets instead of client_assets
 * @returns {string} Polotno page background property.
 */
const convertBackgroundToPolotno = (page, pageSpec, photos, template, useServerAssets) => {
  const { backgroundImage, backgroundColor } = pageSpec;
  const backgroundPlaceholder = page.placeholders.find(p => p.id === 'custom-background');
  if (backgroundPlaceholder) {
    const photo = photos.find(i => i.key === backgroundPlaceholder.data.photo_key);
    if (photo) {
      return photo.url;
    }
  }

  // Background image has the top priority, if it's present, it's used.
  if (backgroundImage != null) {
    return convertBackgroundToAbsoluteUrl(backgroundImage, template, useServerAssets);
  }
  // Background color is the secondary option.
  if (backgroundColor != null) {
    return backgroundColor;
  }

  // when we have cover page with spine - we don't want to show background (which one?)
  if (page.type === 'cover' && page.spine != null) {
    return undefined;
  }

  // Use the default background, if nothing else is present.
  return getDefaultBackground(page, template, useServerAssets);
};

export default convertBackgroundToPolotno;
